import React, { useState } from 'react';
import { Desktop } from './components/Desktop/Desktop';
import { BootScreen } from './components/BootScreen/BootScreen';
import { GlobalStyle } from './styles/globalStyles';
import { Preloader } from './components/Preloader/Preloader';
import { Analytics } from '@vercel/analytics/react';

function App() {
  const [isBooting, setIsBooting] = useState(true);

  const handleBootComplete = () => {
    setIsBooting(false);
  };

  return (
    <React.Fragment>
      <GlobalStyle />
      {isBooting ? (
        <BootScreen onBootComplete={handleBootComplete} />
      ) : (
        <Desktop />
      )}
      <Analytics />
    </React.Fragment>
  );
}

export default App;